/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   Fees bizo
 */

import { Bizo, autoclass } from './base'
import type { Fees as FeesType, RawFees } from './fees.type'

export const Fees: typeof FeesType = autoclass<FeesType, RawFees>(
  'Fees',
  class Fees extends Bizo<FeesType, RawFees> {},
  {
    type: 'type',
    name: 'name',
    cadence: 'cadence',
    amountInCents: 'amount_in_cents',
    isRequired: 'is_required',
    refundable: 'refundable',
    description: 'description',
  }
)

export type Fees = FeesType
